<template>
    <div class="basic ManyTimes">
        <commonHeader :title='data.name' />
        <div class="headTip">
            <p>{{Anniversary.tip8}}</p>
        </div>
        <div class="content">
            <div class="table">
                <div class="section">
                    <div class="sectionItem yxpt">{{Anniversary.tip10}}</div>
                    <div class="sectionItem timeWidth">{{Anniversary.tip11}}</div>
                    <div class="sectionItem">{{Anniversary.tip12}}</div>
                    <div class="sectionItem">{{Anniversary.tip13}}</div>
                    <div class="sectionItem">{{Anniversary.tip14}}</div>
                    <div class="sectionItem">{{Anniversary.tip15}}</div>
                    <div class="sectionItem">{{Anniversary.tip16}}</div>
                </div>
                <el-scrollbar :style="{height:list.length > 10 ? '400px' :'auto'}" :class="list.length > 10 ? 'addclass':''">
                    <template v-if="messageReqSuccessFlag">
                        <ul>
                            <li v-for="(item,index) in list" :key="index">
                                <div class="">
                                    <div class="headView">
                                        <div class="sectionItem yxpt">{{item.vendorCode}}</div>
                                        <div class="sectionItem">{{formatTime(item.betTime)}}</div>
                                        <div class="sectionItem">{{item.betAmount}}</div>
                                        <div class="sectionItem">{{item.rewardTimes}}</div>
                                        <div class="sectionItem">{{item.amount}}</div>
                                        <div class="sectionItem">{{item.remark}}</div>
                                        <div class="sectionItem">
                                            <div v-if="item.status == 1">{{$t('lotteryGold.Received')}}</div>
                                            <div v-else>
                                                <el-button v-if="!data.speActLuckyTimesVO.received" type="danger" size="mini" round @click="submit(item,index)">{{Anniversary.tip17}}</el-button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </template>
                    <template v-else>
                        <p class="noList">--{{Anniversary.tip19}}--</p>
                    </template>
                </el-scrollbar>
            </div>
            <div class="wxtip">
                <p class="title1">
                    <span class="fsiast">{{Anniversary.tip20}}：</span>
                    <span>{{Anniversary.tip21}}</span>
                </p>
                <p class="title2">{{Anniversary.tip22}}&nbsp;&nbsp;<span class="ptTip" @click="toCustomerService">{{Anniversary.tip42}} </span>&nbsp;&nbsp;{{Anniversary.tip23}} </p>
            </div>
            <div class="lastTip">
                <div class="title">{{Anniversary.tip20}}</div>
                <p>{{Anniversary.tip24}}<span style="color:#E91919">{{Anniversary.name2}}</span>{{Anniversary.name3}}</p>
                <p>{{Anniversary.tip25}}</p>
                <p>{{Anniversary.tip26}}{{data.speActLuckyTimesVO.dailyAppCount}}{{Anniversary.name}}<br/>{{Anniversary.tip27}}</p>
                <p>{{Anniversary.tip28}}</p>
                <p>5. {{Anniversary.tip20}}：&nbsp;&nbsp;{{Anniversary.tip29}}<span class="clickon" @click="openDetail">【{{Anniversary.tip9}}】</span>&nbsp;&nbsp;{{Anniversary.tip43}}</p>
            </div>
        </div>
    </div>
</template>
<script>
import commonHeader from './commonHeader.vue'
export default {
    components: {
        commonHeader
    },
    data() {
        return {
            messageReqSuccessFlag:true,
            list:[],
            id:null,
            intro:'',
            data:{
                speActLuckyTimesVO:{
                    dailyAppCount:''
                }
            }
        };
    },
    computed:{
        Anniversary(){
            return this.$t('Anniversary')
        }
    },
    created(){
        this.id = this.$route.query.id;
        this.getData(this.id);
    },
    methods:{
        //点击联系客服
        toCustomerService() {
            if (window.customerServiceStatus == 1) {
                //新客服
                var _this = this;
                var obj = {};
                obj.host = _this.$common.getHost();
                obj.clientCode = window.clientCode;
                obj.clientItem = window.childCode;
                obj.username =
                    this.$common.getUser() && this.$common.getUser().username;
                obj.language = this.$common.getLocale();
                obj.theme = window.theme;
                obj.projectImgUrl = window.projectImgUrl;
                obj.orgin = window.location.origin + "/activity";
                var str = JSON.stringify(obj);
                str = window.btoa(str);
                // var url =
                //     _this.$config.customerServiceUrl +
                //     "/customerService/pc?s=" +
                //     str;
                var url = location.origin + "/func/customerService/pc?s=" + str;
                window.open(url, "_blank");
            } else {
                //旧客服
                const url = this.$common.getCustomerService();
                window.open(url, "_blank");
            }
        },
        //跳转详情
        openDetail(){
            this.$router.push({
                path:'/discount',
                query:{
                    flag:true,
                    name:this.data.name,
                    startTime:this.data.startTime,
                    endTime:this.data.endTime,
                    forever:this.data.forever,
                }
            });
            localStorage.setItem('disIntro',this.intro)
        },
        //获取详情数据
        getData(id) {
            this.$http.get(this.$api.getThematicActivitiesByApp, '/'+id,true)
            .then((res) => {
                if(res.code == 0){
                    this.data = res.data;
                    this.intro = res.data.intro;
                    this.list = res.data.speActLuckyTimesVO.unreceivedList;
                   if(this.list.length == 0){
                       this.messageReqSuccessFlag = false;
                   }
               }
            });
        },
        //领取奖励
        submit(item,index){
            this.$confirm(this.Anniversary.tip30, this.Anniversary.tip33, {
                confirmButtonText: this.Anniversary.tip32,
                cancelButtonText:this.Anniversary.tip34 ,
                type: 'warning'
                }).then(() => {
                        this.$http.put(this.$api.getReceive + item.thematicActivitiesId + '&betNo='+item.betNo ).then((res) => {
                            if(res.code == 0){
                                this.$message({ type: 'success', message: res.data});
                                this.getData(this.id);
                            }else{
                                this.$message({type: 'warning', message: res.msg });
                            }
                       
                        });
              
                }).catch(() => {
            });
        },
        //时间戳转时间
       formatTime(time){
            var date = new Date(time); // 初始化日期
            var year = date.getFullYear(); //获取年份
            var month = date.getMonth() + 1; // 获取月份
            var day = date.getDate(); // 获取具体日
            var hour = date.getHours(); // 获取时
            var minutes = date.getMinutes(); // 获取分
            var seconds = date.getSeconds(); // 获取秒
            return year + '-' + month + '-' + day + ' ' +  hour + ':' + minutes + ':' + seconds 
        },
    }
};
</script>
<style  lang="scss">
    @import url('../../../assets/css/common.css');
   .addclass{
        .el-scrollbar__wrap{
            overflow-x: hidden;
        }
   }
</style>
<style lang="scss" scoped>
.ManyTimes{
    .headTip {
        margin: 20px 0;
        background-color: #FFF4D7;
        color: #E91919;
        font-size: 12px;
        padding: 10px;
    }
    .content{
        .titleFa{
            overflow: hidden;
            margin-bottom: 15px;
            .flag{
                width: 4px;
                height: 21px;
                float: left;
                background: #E91919;
                margin-right: 8px;
            }
            .name{
                font-size: 14px;
                font-weight: bold;
                line-height: 21px;
                float: left;
                color: #333333;
            }
        }
        // 表格样式
        .table{
             font-size: 13px;
             margin-bottom: 10px;
             overflow-x: hidden;
             border-top:2px solid #eaeaea;
            .section {
                background-color: #fff;
                color: #333;
                height: 40px;
                line-height: 40px;
                display: flex;
                flex-direction: row;
            }
            ul{
                border: 1px solid #F5F5F5;
                border-bottom:none;
                margin-bottom: 10px;
            }
            .sectionItem {
                flex:1;
                text-align: center;
            }
            .yxpt{
                width: 100px!important;
            }
            .headView {
                display: flex;
                flex-direction: row;
                align-items: center;
                background-color: #fff; 
                height: 34px;
                line-height: 34px;
                font-size: 12px;
                color: #999999;
                cursor: pointer;
                border-bottom: 1px solid #F5F5F5;
                img {
                    width: 16px;
                    height: 16px;
                }
                .el-button--danger{
                    background: #E91919;
                    font-size: 12px;
                    padding: 5px 10px;
                    box-shadow: 0px 3px 6px rgba(230, 79, 79, 0.16);
                }
            }
            .headView:hover{
                background: #F6F6F6;
            }
            
        }
        .noList{
            background-color: #F5F5F5;
            color: #000;;
            text-align: center;
            height: 34px;
            line-height: 34px;
            border: 1px solid #f5f5f5;
            border-top: none;
        }
        .wxtip{
            margin-top: 20px;
            font-size: 12px;
            line-height: 17px;
            border-bottom: 1px solid #E8E8E8;
            padding-bottom: 20px;
            margin-bottom: 24px;
            .title1{
                margin-bottom: 12px;
                color: #999999;
                .fsiast{
                    color: #333333;
                }
            }
            .title2{
                color: #333333;
                .ptTip{
                    color: #E91919;
                }
            }
        }
        //温馨提示样式
        .lastTip{
            .title{
                font-size: 14px;
                font-weight: 500;
                line-height: 20px;
                color: #E91919;
            }
            p{
                font-size: 12px;
                line-height: 25px;
                color: #333333;
            }
            .clickon{
                color: rgb(0, 102, 255);
            }
        }
    }
}
</style>